import { render } from "./BosinaAndHerzegovina.vue?vue&type=template&id=72fef79f&scoped=true"
import script from "./BosinaAndHerzegovina.vue?vue&type=script&lang=js"
export * from "./BosinaAndHerzegovina.vue?vue&type=script&lang=js"

import "./BosinaAndHerzegovina.vue?vue&type=style&index=0&id=72fef79f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fef79f"]])

export default __exports__